import { render, staticRenderFns } from "./SellCategorySelect.vue?vue&type=template&id=b14baac0"
import script from "./SellCategorySelect.vue?vue&type=script&lang=ts"
export * from "./SellCategorySelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports